module.exports = __webpack_public_path__ + "VIPV2.png?b177ea077eb64d953aaf55d001448cb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV2.png
// module id = 114
// module chunks = 0